export function SwitcherIcon({ extraClass }: SwitcherIconProps): JSX.Element {
  return (
    <div className={`switcher-icon ${extraClass}`}>
      <span>AGENT</span>
    </div>
  );
}
